import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function ThankYou() {
  return (
    <main
      data-testid="thank-you-page"
      className="flex min-h-[70vh] items-center justify-center bg-[#F8FAFC] px-4 py-16 sm:px-6"
    >
      <div className="mx-auto max-w-2xl rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm md:p-12">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#0A2540] text-white">
          <CheckCircle2 size={28} />
        </div>
        <p className="mt-6 font-mono text-xs uppercase tracking-widest text-[#C85A32]">
          Zynqelix S.A.
        </p>
        <h1 className="mt-3 font-serif text-3xl font-bold tracking-tight text-[#0A2540] sm:text-4xl">
          ¡Gracias por su suscripción!
        </h1>
        <p className="mt-4 text-base leading-relaxed text-slate-700">
          Hemos recibido correctamente sus datos. En breve recibirá en su correo electrónico el próximo informe analítico de Zynqelix sobre el mercado argentino de litio, gas y petróleo.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-slate-600">
          Le recomendamos revisar la carpeta de correo no deseado en caso de no encontrar nuestro mensaje en la bandeja principal.
        </p>
        <Link
          to="/"
          data-testid="thank-you-back-home"
          className="mt-8 inline-flex items-center justify-center rounded-md bg-[#C85A32] px-6 py-3 text-sm font-semibold text-white hover:bg-[#B04D28]"
        >
          Volver al inicio
        </Link>
      </div>
    </main>
  );
}
